export const isEqual = (value, other) => JSON.stringify(value) === JSON.stringify(other);
